<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-list me-2"></i>{{ TR.products }}
        </div>

        <div class="card-body">
            <DADataTableLazy
                v-if="tableOptions"
                ref="product_table_ref"
                :tableData="[]"
                :tableOptions="tableOptions"
                :lazyUrl="lazyUrl"
            />
        </div>

    </div>
</template>


<script scoped>
    import { ref, watchEffect, onBeforeMount } from "vue";

    import { useStore } from '@/system_modules/store';
    // import moment from 'moment-timezone';

    // import { useRouter } from "vue-router";
    // import { FilterMatchMode } from 'primevue/api';

    import { G, ajax } from "@/_common";

    import DADataTableLazy from "@/components/table/DADataTableLazy";

    export default {
        name: 'ProductsPage',
        title: 'products',
        components: {
            DADataTableLazy,
        },
        setup () {
            const store = useStore();
            // const router = useRouter();

            const tableOptions = ref();
            const filters = ref([]);
            const category = ref([]);
            const product_table_ref = ref();
            const TR = ref({});

            const requiredFields = [
                'name',
                'price',
            ];

            const lazyUrl = ref(store.getProductsLazy());

            onBeforeMount(async () => {

                // await getProducts();

                await ajax({
                    url: store.getFiltersByGroupID(0),
                    success: (e) => {
                        const res = e.data || null;
                        if (res) {
                            res.forEach(a => {
                                filters.value = filters.value.concat(a.group_filters.map(f => (
                                    { value: f.id, label: `${a.translate[0].name} / ${f.translate[0].name}` }
                                )));
                            });
                        }
                    }
                });

                await ajax({
                    url: store.getCategoryList(),
                    success: (e) => {
                        const res = e.data || null;
                        if (res) {
                            category.value.push({ value: 0, label: `<b>${TR.value.empty}</b>` });
                            category.value = category.value.concat(res.map(a => (
                                { value: a.id, label: a.translate[0].name }
                            )));
                            // res.filter(r => r.parent != 0).forEach(a => {
                            //     category.value.forEach((c, i) => {
                            //         if( a.parent == c.value ){
                            //             category.value.splice(i, 1);
                            //         }
                            //     });
                            // });
                            // category.value = category.value.concat(res.filter(r => r.parent != 0).map(a => (
                            //     { value: a.id, label: a.translate[0].name }
                            // )));
                        }
                    }
                });

                tableOptions.value = {
                    row_total: false,
                    // row_total_field: ['price'],
                    // row_total_function: {
                    //     "price": (r) => {
                    //         return r["eded"] * r["price"];
                    //     },
                    // },
                    date_columns: {'date_inserted': 'datetime'},
                    // row_per_page: 5,
                    // export_button: false,

                    header_buttons:[
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: 'fas fa-plus me-1',
                            class: 'btn-primary',
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    page: 'pages/products/ProductsInfo',
                                    data: {
                                        permission_method: 'add'
                                    },
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            field_type: "text",
                                            required: true,
                                        },
                                        {
                                            name: "description",
                                            title: TR.value.about,
                                            field_type: "editor",
                                        },
                                    ],
                                    // category_id, mal_kod, mal_ad, top_qiymet, per_qiymet, eded, cin_qiy, kub, per_qiymet_rayon, karobka_sayi, karobka_ic_sayi, istehsalci, anbar, web_publish, row_status
                                    table_columns: [
                                        {
                                            name: "category_id",
                                            title: TR.value.category,
                                            // field_type: "dropdown_group",
                                            field_type: "dropdown",
                                            dropdown_items: category.value,
                                            dropdown_item_selected: category.value[0].value,
                                            // grouping: true,
                                            // groupLabelField: 'label',
                                            // groupItemsField: 'items',
                                        },
                                        // {
                                        //     name: "product_filters",
                                        //     title: TR.value.filters,
                                        //     field_type: "multiselect",
                                        //     dropdown_items: filters.value,
                                        //     dropdown_item_selected: [],
                                        //     // onChange: (e, s) => {
                                        //     //     console.log(s, e);
                                        //     //     (document.getElementById('EventTypeSelection')
                                        //     //         .getElementsByClassName('ui-multiselect-label-container')[0]
                                        //     //         .getElementsByClassName('ui-multiselect-label')[0]).textContent = this.SelectedEventTypes.length + ' ausgewählt';
                                        //     // }
                                        // },
                                        {
                                            name: "mal_kod",
                                            title: TR.value.code,
                                            field_type: "text",
                                            // required: true,
                                        },
                                        {
                                            name: "mal_ad",
                                            title: TR.value.mal_ad,
                                            field_type: "text",
                                            // required: true,
                                        },
                                        {
                                            name: "eded",
                                            title: TR.value.quantity,
                                            field_type: "integer",
                                            required: true,
                                            grouping: false,
                                            default: 0,
                                            max: 1000000,
                                        },
                                        {
                                            name: "cin_qiy",
                                            title: TR.value.cin_qiy,
                                            field_type: "numeric",
                                            required: true,
                                            max: 1000000.000,
                                            default: 0,
                                            grouping: true,
                                        },
                                        {
                                            name: "top_qiymet",
                                            title: TR.value.top_qiymet,
                                            field_type: "numeric",
                                            required: true,
                                            max: 1000000.000,
                                            default: 0,
                                            grouping: true,
                                        },
                                        {
                                            name: "price",
                                            // name: "per_qiymet",
                                            title: TR.value.price,
                                            // field_type: "currency",
                                            field_type: "numeric",
                                            required: true,
                                            max: 1000000.000,
                                            default: 0,
                                            grouping: true,
                                        },
                                        {
                                            name: "per_qiymet_rayon",
                                            title: TR.value.per_qiymet_rayon,
                                            field_type: "numeric",
                                            max: 1000000.000,
                                            default: 0,
                                            grouping: true,
                                        },
                                        {
                                            name: "kub",
                                            title: "kub",
                                            field_type: "numeric",
                                            max: 1000000.00,
                                            default: 0,
                                        },
                                        {
                                            name: "karobka_sayi",
                                            title: TR.value.karobka_sayi,
                                            field_type: "text",
                                        },
                                        {
                                            name: "karobka_ic_sayi",
                                            title: TR.value.karobka_ic_sayi,
                                            field_type: "text",
                                        },
                                        {
                                            name: "istehsalci",
                                            title: TR.value.istehsalci,
                                            field_type: "integer",
                                            grouping: false,
                                            max: 1000000,
                                        },
                                        {
                                            name: "anbar",
                                            title: TR.value.anbar,
                                            field_type: "text",
                                        },
                                        {
                                            name: "web_publish",
                                            title: TR.value.web_publish,
                                            value: () => false,
                                            field_type: "switch",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;
                                                        // console.log(e, requiredFields.filter(a => e[a] === undefined || e[a] == null || e[a] == '' || e[a].length == 0 || (e[a] instanceof Object && (e[a][1] === undefined || e[a][1] == '')) ).length);

                                                        if( e.totalSize < G.uploadedFileSize && requiredFields.filter(a => e[a] === undefined || e[a] == null || e[a] == '' || e[a].length == 0 || (e[a] instanceof Object && (e[a][1] === undefined || e[a][1] == ''))).length == 0 ){
                                                            let formData = new FormData();

                                                            if( e.images.length ){
                                                                Array.from(e.images).forEach(file => {
                                                                    if( file instanceof Object ){
                                                                        formData.append('upload_image', file);
                                                                    }
                                                                });
                                                            }
                                                            // e.files.forEach(file => {
                                                            //     fna.push(file.name);
                                                            //     if( file instanceof Object && file.objectPath !== undefined ){
                                                            //         formData.append( "upload_image", file );
                                                            //     }
                                                            // });

                                                            let product_data = {
                                                                "category_id": e.category_id || null,

                                                                "mal_kod": e.mal_kod,
                                                                "mal_ad": e.mal_ad,
                                                                "top_qiymet": e.top_qiymet,
                                                                // "per_qiymet": e.per_qiymet,
                                                                "eded": e.eded,
                                                                "cin_qiy": e.cin_qiy,
                                                                "kub": e.kub,
                                                                "per_qiymet_rayon": e.per_qiymet_rayon,
                                                                "karobka_sayi": e.karobka_sayi,
                                                                "karobka_ic_sayi": e.karobka_ic_sayi,
                                                                "istehsalci": e.istehsalci,
                                                                "anbar": e.anbar,

                                                                "price": e.price,

                                                                "web_publish": e.web_publish ? 1 : 0,
                                                                "status": e.status ? 1 : 0,
                                                                "translate": G.lang_list.map((a) => (
                                                                    {
                                                                        "lang_id": a.value,
                                                                        "name": e.name[a.value] || e.name[1],
                                                                        "description": e.description[a.value],
                                                                    }
                                                                )),
                                                                "product_images": e.new_product_images,
                                                                "product_filters": e.product_filters,
                                                            };

                                                            formData.append("data", JSON.stringify(product_data));

                                                            await ajax({
                                                                url: store.getProducts(),
                                                                method: 'post',
                                                                data: formData,
                                                                success: (x) => {
                                                                    const res1 = x.data || null;
                                                                    if ( x.status == 200 && res1) {
                                                                        product_table_ref.value.tableData.unshift(res1);
                                                                        // product_table_ref.value.reCalculateTotal();
                                                                        G.alert.success(TR.value.msg_add_success);
                                                                        G.closeModal(res);
                                                                    }
                                                                    else
                                                                        G.alert.error(res1.detail);
                                                                },
                                                            });
                                                        }
                                                        else if(e.totalSize >= G.uploadedFileSize){
                                                            G.alert.info({msg: TR.value.msgInvalidFileSize.replace('{0}', `${G.formatSize(G.uploadedFileSize)}`), position: 'center'});
                                                        }
                                                        else{
                                                            G.alert.info({msg: TR.value.msg_fill_required_field, position: 'center'});
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_remove_user, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getProductsUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            const res = e.data || null;
                                            product_table_ref.value.tableData.filter((x, i) => { if (x.id === data.id) product_table_ref.value.tableData.splice(i, 1); } );
                                            // product_table_ref.value.reCalculateTotal();
                                            G.alert.success(res.detail);
                                        },
                                        // error: (e) => {
                                        //     const res = e.response || null;
                                        //     G.alert.error(res.detail);
                                        // }
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method = 'update';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: data.mal_kod,
                                    page: "pages/products/ProductsInfo",
                                    data: data,
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            // value: (e) => e.translate[0].name,
                                            value: (l) => l.name,
                                            field_type: "text",
                                            alternative_name_field: "mal_ad",
                                            required: true,
                                        },
                                        {
                                            name: "description",
                                            title: TR.value.description,
                                            // value: (e) => e.translate[0].description,
                                            value: (l) => l.description,
                                            field_type: "editor",
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        {
                                            name: "category_id",
                                            title: TR.value.category,
                                            value: "category_id",
                                            field_type: "dropdown",
                                            dropdown_items: category.value,
                                            dropdown_item_selected: data.category_id,
                                        },
                                        // {
                                        //     name: "product_filters",
                                        //     title: TR.value.filters,
                                        //     // value: "product_filters",
                                        //     field_type: "multiselect",
                                        //     dropdown_items: filters.value,
                                        //     dropdown_item_selected: data.product_filters?.map(f => f.filter_id),
                                        //     // dropdown_item_selected: data.filters.map(c => c.filter_id),
                                        // },
                                        {
                                            name: "mal_kod",
                                            title: TR.value.code,
                                            value: "mal_kod",
                                            field_type: "text",
                                            // required: true,
                                        },
                                        {
                                            name: "mal_ad",
                                            title: TR.value.mal_ad,
                                            value: "mal_ad",
                                            field_type: "text",
                                            // required: true,
                                        },
                                        {
                                            name: "eded",
                                            title: TR.value.quantity,
                                            value: "eded",
                                            field_type: "integer",
                                            required: true,
                                            grouping: false,
                                            default: 0,
                                            max: 1000000,
                                        },
                                        {
                                            name: "cin_qiy",
                                            title: TR.value.cin_qiy,
                                            value: "cin_qiy",
                                            field_type: "numeric",
                                            required: true,
                                            max: 1000000.000,
                                            default: 0,
                                            grouping: true,
                                        },
                                        {
                                            name: "top_qiymet",
                                            title: TR.value.top_qiymet,
                                            value: "top_qiymet",
                                            field_type: "numeric",
                                            required: true,
                                            max: 1000000.000,
                                            default: 0,
                                            grouping: true,
                                        },
                                        {
                                            name: "price",
                                            // name: "per_qiymet",
                                            title: TR.value.price,
                                            value: "price",
                                            // field_type: "currency",
                                            field_type: "numeric",
                                            required: true,
                                            max: 1000000.000,
                                            default: 0,
                                            grouping: true,
                                        },
                                        {
                                            name: "per_qiymet_rayon",
                                            title: TR.value.per_qiymet_rayon,
                                            value: "per_qiymet_rayon",
                                            field_type: "numeric",
                                            max: 1000000.000,
                                            default: 0,
                                            grouping: true,
                                        },
                                        {
                                            name: "kub",
                                            title: TR.value.kub,
                                            value: "kub",
                                            field_type: "numeric",
                                            max: 1000000.00,
                                            default: 0,
                                        },
                                        {
                                            name: "karobka_sayi",
                                            title: TR.value.karobka_sayi,
                                            value: "karobka_sayi",
                                            field_type: "text",
                                        },
                                        {
                                            name: "karobka_ic_sayi",
                                            title: TR.value.karobka_ic_sayi,
                                            value: "karobka_ic_sayi",
                                            field_type: "text",
                                        },
                                        {
                                            name: "istehsalci",
                                            title: TR.value.istehsalci,
                                            value: "istehsalci",
                                            field_type: "integer",
                                            grouping: false,
                                            max: 1000000,
                                        },
                                        {
                                            name: "anbar",
                                            title: TR.value.anbar,
                                            value: "anbar",
                                            field_type: "text",
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                        {
                                            name: "web_publish",
                                            title: TR.value.web_publish,
                                            value: (e) => e.web_publish == 1 ? true : false,
                                            field_type: "switch",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e.totalSize < G.uploadedFileSize && requiredFields.filter(a => e[a] === undefined || e[a] == null || e[a] == '' || e[a].length == 0 || (e[a] instanceof Object && (e[a][1] === undefined || e[a][1] == ''))).length == 0 ){
                                                            let formData = new FormData();
                                                            if( e.images.length ){
                                                                Array.from(e.images).forEach(file => {
                                                                    if( file instanceof Object ){
                                                                        formData.append('upload_image', file);
                                                                    }
                                                                });
                                                            }

                                                            let product_data = {
                                                                // category_id, mal_kod, mal_ad, top_qiymet, per_qiymet, eded, cin_qiy, kub, per_qiymet_rayon, karobka_sayi, karobka_ic_sayi, istehsalci, anbar, web_publish, row_status
                                                                "category_id": e.category_id || null,
                                                                "mal_kod": e.mal_kod,
                                                                "mal_ad": e.mal_ad,
                                                                "top_qiymet": e.top_qiymet,
                                                                // "per_qiymet": e.per_qiymet,
                                                                "eded": e.eded,
                                                                "cin_qiy": e.cin_qiy,
                                                                "kub": e.kub,
                                                                "per_qiymet_rayon": e.per_qiymet_rayon,
                                                                "karobka_sayi": e.karobka_sayi,
                                                                "karobka_ic_sayi": e.karobka_ic_sayi,
                                                                "istehsalci": e.istehsalci,
                                                                "anbar": e.anbar,

                                                                "price": e.price,

                                                                "web_publish": e.web_publish ? 1 : 0,
                                                                "status": e.status ? 1 : 0,
                                                                "translate": G.lang_list.map((a) => (
                                                                    {
                                                                        "lang_id": a.value,
                                                                        "name": e.name[a.value] || e.name[1],
                                                                        "description": e.description[a.value],
                                                                    }
                                                                )),
                                                                "product_images": e.new_product_images,
                                                                "product_filters": e.product_filters,
                                                            };

                                                            formData.append("data", JSON.stringify(product_data));

                                                            await ajax({
                                                                url: store.getProductsUpdate(data.id),
                                                                method: 'patch',
                                                                data: formData,
                                                                success: (x) => {
                                                                    const res1 = x.data || null;
                                                                    if ( x.status == 200 && res1) {
                                                                        // product_table_ref.value.tableData.forEach(
                                                                        //     (s) => { if ( s.id === res.id ) { s = res; } }
                                                                        // );
                                                                        for (let a in res1) {
                                                                            data[a] = res1[a];
                                                                        }
                                                                        // product_table_ref.value.reCalculateTotal();
                                                                        G.alert.success(TR.value.msg_update_success);
                                                                        G.closeModal(res);
                                                                    }
                                                                    else{
                                                                        G.alert.error(res1.detail);
                                                                    }
                                                                },
                                                            });
                                                        }
                                                        else if(e.totalSize >= G.uploadedFileSize){
                                                            G.alert.info({msg: TR.value.msgInvalidFileSize.replace('{0}', `${G.formatSize(G.uploadedFileSize)}`), position: 'center'});
                                                        }
                                                        else{
                                                            G.alert.info({msg: TR.value.msg_fill_required_field, position: 'center'});
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getProductsActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data || undefined;
                                        if ( a.status == 200 && res) {
                                            // res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime']));
                                            // res.create_date = moment.utc(res.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['datetime']);
                                            // res.create_date = new Date(res.create_date);
                                            product_table_ref.value.tableData.forEach(
                                                (s) => { if ( s.id === res.id ) { s = res; } }
                                            );
                                            for (let a in res) {
                                                data[a] = res[a];
                                            }
                                            product_table_ref.value.reCalculateTotal();
                                            G.alert.success({toast: true, msg: TR.value.msg_update_success});
                                        }
                                        else{
                                            G.alert.error(res.detail);
                                        }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "image",
                            value: (e) => {
                                return `<img
                                src="${
                                    e.product_images?.length && e.product_images[0]
                                    && e.product_images[0].image instanceof Object === false //&& e.product_images[0].image.match(/^http[\s]?:\/\//mgi)
                                                    ? e.product_images[0].image
                                                    : "/assets/img/noimg.png"
                                            }"
                                            alt="${e.product_images?.length ? e.product_images[0].image : ''}"
                                            class="border img-circle-cover"
                                        />`},
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            filter: false,
                        },
                        {
                            name: "mal_kod",
                            value: 'mal_kod',
                            title: `${TR.value.code}`,
                        },
                        {
                            name: "mal_ad",
                            value: (e) => e.translate?.length ? e.translate[0].name : e.mal_ad,
                            title: `${TR.value.name}`,
                        },
                        {
                            name: "category_id",
                            title: TR.value.category,
                            value: (e) => e.category?.translate ? e.category.translate[0].name : '',
                            // value: (e) => e.category_id && category.value.length ? category.value.filter((c) => c.value === e.category_id)[0].label : '',
                            filters: {
                                operator: "or",
                                constraints: [
                                    { value: null, matchMode: 'equals' },
                                ],
                            },
                            class: "text-center",
                            data_type: "customFilter",
                            filter_field: "category_id",
                            filter_mode: "dropdown",
                            dropdown_items: category.value,
                        },
                        {
                            name: "eded",
                            value: "eded",
                            title: TR.value.count,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "gte" }],
                            },
                            data_type: "numeric",
                            // filter_mode: "currency",
                        },
                        {
                            name: "price",
                            value: "price",
                            title: TR.value.price,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "gte" }],
                            },
                            data_type: "numeric",
                            filter_mode: "currency",
                        },
                        {
                            name: "top_qiymet",
                            value: "top_qiymet",
                            title: TR.value.top_qiymet,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "gte" }],
                            },
                            data_type: "numeric",
                            filter_mode: "currency",
                            visible: false,
                        },
                        {
                            name: "cin_qiy",
                            value: "cin_qiy",
                            title: TR.value.cin_qiy,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "gte" }],
                            },
                            data_type: "numeric",
                            filter_mode: "currency",
                            visible: false,
                        },
                        {
                            name: "karobka_sayi",
                            value: "karobka_sayi",
                            title: TR.value.karobka_sayi,
                            visible: false,
                        },
                        {
                            name: "karobka_ic_sayi",
                            value: "karobka_ic_sayi",
                            title: TR.value.karobka_ic_sayi,
                            visible: false,
                        },
                        {
                            name: "kub",
                            value: "kub",
                            title: TR.value.kub,
                            visible: false,
                        },
                        {
                            name: "istehsalci",
                            value: "istehsalci",
                            title: TR.value.manufacturer,
                            visible: false,
                        },
                        {
                            name: "anbar",
                            value: "anbar",
                            title: TR.value.anbar,
                            visible: false,
                        },
                        {
                            name: "date_inserted",
                            value: "date_inserted",
                            // value: (e) => G.formatLocale(e.create_date),
                            title: TR.value.create_date,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            filter_format: 'dd.mm.yy',
                            data_type: "date",
                            filter_mode: "datetime",
                        },
                        {
                            name: 'web_publish',
                            title: TR.value.web_publish,
                            value: (e) => e.web_publish == 1 ? true : false,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getProductsWEBActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data || undefined;
                                        if ( a.status == 200 && res) {
                                            for (let a in res) {
                                                data[a] = res[a];
                                            }
                                            G.alert.success({toast: true, msg: TR.value.msg_update_success});
                                        }
                                        else{
                                            G.alert.error(res.detail);
                                        }
                                    }
                                });
                            },
                            filter: false,
                            sortable: true,
                            exportable: true,
                        },

                        // {
                        //     name: "web_publish",
                        //     title: TR.value.status + ' aktiv / passiv',
                        //     value: (e) => e.web_publish == 1 ? true : false,
                        //     class: 'text-center',
                        //     element: 'checkbox',
                        //     // checkbox_label: (e) => e.status == 1 ? 'aktiv' : 'passiv',
                        //     eventName: 'change',
                        //     eventCallback: async (event, dstdata) => {
                        //         await ajax({
                        //             url: store.getters.getProductsWEBActivate(dstdata.id, event.target.checked ? 1 : 2),
                        //             method: 'post',
                        //             success: (e) => {
                        //                 G.toast.success({msg: TR.value.msg_update_success});
                        //                 meeting_table_ref.value.loadLazyData();
                        //             },
                        //             error: (e) => {
                        //                 G.toast.danger({msg: e.data.detail});
                        //             }
                        //         });
                        //     },
                        //     filter: false,
                        //     sortable: false,
                        //     exportable: false,
                        // },
                    ],
                };

            });


            // var timeoutValue = null;
            // const getProductCodes = (event, item) => {
            //     if( timeoutValue )
            //         clearTimeout(timeoutValue);
            //     timeoutValue = setTimeout(async () => {
            //         var scode = G.strip(event.target.value, ' ');
            //         if( scode != '' ){
            //             await ajax({
            //                 url: store.getProductCodes( scode ),
            //                 success: (e) => {
            //                     // item.showList = true;
            //                     if( e.status == 200 && e.data ){
            //                         item.selectbox_items = e.data.map((x) => { return {"label": x.product_code} })
            //                     }
            //                 }
            //             });
            //         }
            //     }, 500);
            // };


            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            return {
                TR,
                product_table_ref,
                tableOptions,
                lazyUrl,
                // getProductCodes,
            };
        },
    };
</script>

